define(
  'ItemName.Helper',
  [],
  function () {
    'use strict';

    var SEPARATOR = ' – ';

    var ENTITIES = {
      '&nbsp;': ' ',
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': '\'',
      '&apos;': '\''
    };

    function cleanText(value) {
      if (value === null || typeof value === 'undefined') {
        return '';
      }

      return String(value)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&(nbsp|amp|lt|gt|quot|#39|apos);/g, function (entity) {
          return ENTITIES[entity];
        })
        .replace(/\s+/g, ' ')
        .trim();
    }

    function composeName(fields) {
      var sku = cleanText(fields.sku);
      var displayName = cleanText(fields.displayName);
      var description = cleanText(fields.description);

      // The Items API returns the itemid in storedisplayname2 when the
      // Web Store Display Name is empty.
      if (displayName === sku) {
        displayName = '';
      }

      if (displayName && description) {
        return displayName + SEPARATOR + description;
      }

      return displayName ||
        description ||
        cleanText(fields.salesDescription) ||
        sku;
    }

    return {
      cleanText: cleanText,
      composeName: composeName
    };
  });
